import { createAsyncThunk } from "@reduxjs/toolkit"

import {
  setManutenzione,
  addManutenzione,
  addManutenzioneId,
  updateManutenzione,
  deleteManutenzione,
  apiRequestFailure,
  apiRequestStart,
  apiRequestSuccess,
  enumRequestFailure,
  enumRequestStart,
  enumRequestSuccess,
  setTipologiaIntervento,
  setStatoIntevento
} from "./manutenzioneSlice"
import manutenzioneAPI from "../../services/manutenzioneAPI"
import { toast } from "react-toastify";



export const fetchManutenzione = createAsyncThunk(
  "manutenzioneData/fetchManutenzione",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await manutenzioneAPI.getAllManutenzione();
      dispatch(setManutenzione(response.data.data));
      // console.log(response.data.data, 'data of fetch');

      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch manutenzione.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const singleManutenzione = createAsyncThunk(
  "manutenzioneData/fetchSingleManutenzione",
  async (id, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await manutenzioneAPI.getSingleManutenzione(id);
      // Make sure we're storing the data properly in state
      dispatch(addManutenzioneId(response.data.data));

      // Add logging to debug
      // console.log("Single Manutenzione data:", response.data.data);

      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch single prodotto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
)

// Create new prodotto
export const createManutenzioneData = createAsyncThunk(
  "manutenzioneData/createManutenzione",
  async (payload, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await manutenzioneAPI.createManutenzione(payload);
      dispatch(addManutenzione(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create manutenzione.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Update prodotto
export const updateManutenzioneData = createAsyncThunk(
  "manuTenzioneData/updateManutenzioneData",
  async ({ id, data }, { dispatch }) => {
    // console.log(id, data, "jjjjnature")
    dispatch(apiRequestStart());
    try {
      const response = await manutenzioneAPI.updateManutenzione(id, data);
      dispatch(updateManutenzione(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update prodotto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Delete prodotto
export const deleteManutenzioneData = createAsyncThunk(
  "manutenzioneData/deleteManutenzione",
  async (id, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      await manutenzioneAPI.deleteManutenzione(id);
      dispatch(deleteManutenzione(id));
      dispatch(apiRequestSuccess());
      return id;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete prodotto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fix fetchTipologia to dispatch setTipologia instead of selectTipologia
export const fetchTipologiaIntervano = createAsyncThunk(
  "manutenzioneData/fetchTipologiaIntervano",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("tipologia"));
    try {
      const response = await manutenzioneAPI.getTipologiaIntervano();
      // console.log("Tipologia API Response:", response.data.data);
      dispatch(setTipologiaIntervento(response.data.data)); // Use setTipologia action instead of selectTipologia
      dispatch(enumRequestSuccess("tipologia"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch tipologia.";
      dispatch(
        enumRequestFailure({
          enumType: "tipologia",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  }
);
export const fetchStatoIntervento = createAsyncThunk(
  "manutenzioneData/fetchStatoIntervento",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("statoIntervento"));
    try {
      const response = await manutenzioneAPI.getStatoIntervento();
      // console.log("statoIntervento API Response:", response.data.data);
      dispatch(setStatoIntevento(response.data.data));
      dispatch(enumRequestSuccess("statoIntervento"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch statoIntervento.";
      dispatch(
        enumRequestFailure({
          enumType: "statoIntervento",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  }
);


